import axios from 'axios'
import {
    ConfigurationPersonnelTopographicCodeAssignmentCreateRequest,
    ConfigurationPersonnelTopographicCodeAssignmentResponse
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-topographic-code-assignment/configuration-personnel-topographic-code-assignment.dto'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'

class ConfigurationPersonnelTopographicCodeAssignmentService {
    async create(laboratoryId: number, request: ConfigurationPersonnelTopographicCodeAssignmentCreateRequest): Promise<ConfigurationPersonnelTopographicCodeAssignmentResponse> {
        const response = await axios.post<ConfigurationPersonnelTopographicCodeAssignmentResponse>(`/configuration/laboratories/${laboratoryId}/personnelTopographicCodeAssignments`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationPersonnelTopographicCodeAssignmentResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationPersonnelTopographicCodeAssignmentResponse>>(`/configuration/laboratories/${laboratoryId}/personnelTopographicCodeAssignments`, { ...filterModel }, { params })
        return response.data
    }

    async delete(personnelTopographicCodeAssignmentId: number, laboratoryId: number): Promise<void> {
        const response = await axios.delete<void>(`/configuration/laboratories/${laboratoryId}/personnelTopographicCodeAssignments/${personnelTopographicCodeAssignmentId}`)
        return response.data
    }
}

export const configurationPersonnelTopographicCodeAssignmentService = new ConfigurationPersonnelTopographicCodeAssignmentService()
